module.exports = __webpack_public_path__ + "static/media/ssg14.ba3acda8.png";